import {
  ThunkActionType,
  ThunkActionDispatch,
} from "@typings/reduxThunkActions";

import { Viewports } from "@ui/themes/ThemeInterface";

import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";

const actionCreator = new ReduxActionNameCreator("viewport", true);

export const SET_VIEWPORT = actionCreator.make("set viewport");

export const setViewport: ThunkActionType =
  (payload: Viewports) => (dispatch: ThunkActionDispatch) =>
    dispatch({ type: SET_VIEWPORT, payload });
